var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "region-selector-dropdown",
      class: _vm.dropdownOpen ? "region-focused" : "region-blurred"
    },
    [
      _c(
        "div",
        {
          staticClass: "dropdown-head",
          attrs: { "data-testid": "regionSelectorToggle" },
          on: { click: _vm.toggleRegionDropdown }
        },
        [
          _c("span", { staticClass: "country-name" }, [
            _vm._v(_vm._s(_vm.localeName))
          ]),
          _vm._v(" "),
          _c("span", [
            _c("span", { staticClass: "paren" }, [_vm._v("(")]),
            _vm._v(_vm._s(_vm.countryCode)),
            _c("span", { staticClass: "paren" }, [_vm._v(")")])
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "language language-text" }, [
            _vm._v(_vm._s(_vm.language))
          ]),
          _vm._v(" "),
          _c("NsIcon", {
            staticClass: "region-arrow-down",
            attrs: {
              "icon-name": "icon-narrow-angle-bottom-24",
              size: "custom"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-body",
          attrs: { "data-testid": "regionSelectorBody" },
          on: { click: _vm.close, mouseleave: _vm.close }
        },
        [
          _vm._l(_vm.otherLanguages, function(lang) {
            return _c(
              "a",
              {
                key: lang.languageCode,
                staticClass: "dropdown-selection",
                class: { active: lang.languageCode === _vm.languageCode },
                attrs: { href: lang.href },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.selectLanguage(lang.languageCode, lang.href)
                  }
                }
              },
              [
                _c("span", { staticClass: "language-text" }, [
                  _vm._v(_vm._s(lang.language))
                ])
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "dropdown-selection",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.selectOtherRegion($event)
                }
              }
            },
            [
              _c("span", { staticClass: "region" }, [
                _vm._v(" " + _vm._s(_vm.translations.selectOther) + "... ")
              ])
            ]
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }